<template>
    <div>
        <h5>{{ label('Debrief') }} Details</h5>
        <div class="grid">
            <div class="col-12 md:col-6">
                <incident-details />
            </div>
            <div class="col-12 md:col-6">
                <learning-outcomes-details :author="debriefAuthor" :debriefCreation="debriefCreationDate" />
            </div>
        </div>

        <Card>
            <template v-slot:content>
                <div class="flex justify-content-end">
                <Button label="Go Back" icon="pi pi-arrow-left" @click="router.go(-1)" />
                </div>
            </template>
        </Card>
    </div>
</template>
<script setup>
import IncidentDetails from '../../incident/modules/IncidentDetails.vue';
import LearningOutcomesDetails from '../../learning-outcome/modules/LearningOutcomesDetails.vue';
import { onMounted, onUnmounted, computed, defineProps, ref } from 'vue';
import { applianceStore, debriefStore, incidentStore, learningOutcomeStore } from '../../../../../store/global-stores';
import { formatDisplayDate } from '@/utilities/date-formatter';
import router from '@/router';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();

const props = defineProps({
    id: {
        type: [Number, String],
        required: true,
    },
});

const debriefId = computed(() => {
    return props.id;
});

onMounted(() => {
    if (debriefId.value) {
        loadDebriefDetails(debriefId.value);
    }
});

onUnmounted(() => {
    debriefStore.initDebrief();
});

const debriefAuthor = ref('');
const debriefCreationDate = ref('');

const loadDebriefDetails = async (id) => {
    const debriefDetails = await debriefStore.fetchDebriefDetails(id);

    console.log(debriefDetails);

    debriefAuthor.value = debriefDetails?.author?.name + ' ' + debriefDetails?.author?.surname;
    debriefCreationDate.value = formatDisplayDate(debriefDetails?.created_at);

    // load incident details
    incidentStore.loadIncidentDetails(debriefDetails.incident);
    //load appliance details
    applianceStore.loadApplianceBody(debriefDetails.appliance);
    // load debrief details
    debriefStore.loadEditDebrief(debriefDetails);
    // load learning outcome details
    learningOutcomeStore.loadEditLearningOutcomes(debriefDetails.learning_outcome);
};
</script>
<style>
.container {
    display: flex;
    flex-wrap: wrap;
}

.row {
    width: 100%;
    display: flex;
    align-items: center;
}
.row:nth-child(odd) {
    background-color: rgba(0, 0, 0, 0.075);
}
.row:nth-child(even) {
    background-color: #fff;
}
.col-left {
    width: 30%;
    padding: 15px;
}

.col-right {
    width: 70%;
    padding: 15px;
}

.btnContainer {
    display: flex;
    align-content: center;
}
.updateTaskbtn {
    max-width: 120px;
}
.incidentTab {
    width: 100%;
}
</style>
